<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col><component :is="'pMultiselect'" :item="itemTipoDocumento" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger" /></v-col>
              <v-col><v-text-field :label="locDocumento.codice ? 'Numero documento' : 'Numero documento (auto)'" hide-details outlined dense disabled :value="codice"></v-text-field></v-col>
              <v-col><component :is="'pData'" :item="itemData" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense v-if="magazzinoVisibile">
              <v-col lg="6"><component :is="'pMultiselect'" :item="itemMagazzino" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModificaNoTrasforma" :updateTrigger="updateTrigger"/></v-col>
              <v-col lg="6" v-if="magazzino2Visibile"><component :is="'pMultiselect'" :item="itemMagazzino2" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnlySeModificaNoTrasforma" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense v-if="locDocumento.appoggio && locDocumento.appoggio.pagamentoVisibile">
              <v-col><component :is="'pMultiselect'" :item="itemPagamentoModalita" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pMultiselect'" :item="itemPagamentoCondizioni" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense>
              <v-col><importa-da-parcheggio v-show="mostraParcheggio" :show="mostraParcheggio"/></v-col>
            </v-row>             
          </v-card>  
        </v-col>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col v-if="locDocumento.appoggio && locDocumento.appoggio.clienteVisibile"><component :is="'pClifor'" :item="itemCliente" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col> <!-- :disabled="readOnlySeModifica" -->
              <v-col v-if="locDocumento.appoggio && locDocumento.appoggio.fornitoreVisibile"><component :is="'pClifor'" :item="itemFornitore" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col> <!-- :disabled="readOnlySeModifica" -->
            </v-row>
            <v-row dense v-if="locDocumento.appoggio && locDocumento.appoggio.spedizioneVisibile">
              <v-col><component :is="'pDestinazioni'" :item="itemDestinazione" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense v-if="locDocumento.appoggio && (locDocumento.appoggio.clienteVisibile || locDocumento.appoggio.fornitoreVisibile)">
              <v-col><component :is="'pTesto'" :item="itemCodiceFiscale" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemPartitaIva" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemCodiceSdi" :appoggio="locDocumento.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-btn v-if="altriDocumentiAbilitato" color="blue-grey" class="white--text" @click="onAltriDocumenti">
            Altri documenti
            <v-icon v-if="presenzaDocumenti" right dark color="yellow" title="Sezione compilata - Presenza informazioni">mdi-text-box-edit-outline</v-icon>
          </v-btn>
<!--           <v-btn color="blue-grey" class="white--text ml-2">
            Dati trasporto
            <v-icon right dark color="yellow" title="Sezione compilata - Presenza informazioni">mdi-text-box-edit-outline</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>
    </v-container>
    <v-alert :value="noPagamento" dismissible prominent dense type="warning">Attenzione! Il cliente non ha un pagamento in anagrafica! Il valore è richiesto per la generazione della Fattura Elettronica</v-alert>
    <altri-documenti :show="dialogAltriDocumenti" :item="locDocumento" @aggiornaDocumento="onAggiornaDocumento" @dialog-close="dialogAltriDocumenti=false"></altri-documenti>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import pMultiselect from './elementi/multiselect'
import pData from './elementi/data'
import pClifor from './elementi/clifor'
import pDestinazioni from './elementi/destinazioni'
import pTesto from './elementi/testo'
import ImportaDaParcheggio from '@/views/ordiniFornitore/components/edit/importaDaParcheggio'
import AltriDocumenti from './ulterioriInformazioni/altriDocumenti'

export default {
  components: {
    pMultiselect,
    pData,
    pClifor,
    pDestinazioni,
    pTesto,
    ImportaDaParcheggio,
    AltriDocumenti
  },
  props: {
    locDocumento: Object,
    trigger: Number,
    filtraTipiDocumento: Array,
    mostraParcheggio: Boolean,
    forzaTipo: Object,
    headerReadOnly: { type: Boolean, default: false }
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1,
    dialogAltriDocumenti: false
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
  },
  watch: {
    async forzaTipo(tipo) {
      const data = {
        model: 'tipoDocumento.codice',
        subModel: 'codice',        
        value: tipo
      }
      await this.componentValueChange(data)
    },    
    async locDocumento(value) {
      // this.locDocumento = await documenti.getDocumento(value)
      // this.locDocumento = value
    },
    trigger() {
    }
  },
  computed: {
    altriDocumentiAbilitato() {
      return this.trigger && this.locDocumento.anagrafica && !this.mostraParcheggio
    },    
    presenzaDocumenti() {
      return this.locDocumento && this.locDocumento.documentiCollegati && this.locDocumento.documentiCollegati.length > 0
    },
    noPagamento() {
      const pagamentoPresente = this.updateTrigger && this.locDocumento && this.locDocumento.pagamento ? true : false
      const pagamentoInserito = pagamentoPresente && this.locDocumento.pagamento.condizioni !== ''
      console.log(pagamentoPresente, pagamentoInserito)
      return pagamentoPresente && !pagamentoInserito ?  true : false
    },
    documentoItems() {
      if (!this.locDocumento || !this.backoffice || !this.updateTrigger) {
        return []
      }
      const vars = this.backoffice.documenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        // items.push({value: dot.pick(item.valueField, this.locDocumento, ''), ...item})
        items.push({value: _.get(this, `locDocumento.${item.valueField}`, ''), ...item})
      }
      // console.log(items)
      return items
    },
    codice() {
      return this.trigger && this.locDocumento && this.locDocumento.codice
    },
    cliente() {
      return _.get(this.locDocumento, 'anagrafica.cliente')
    },
    pagamentoVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.pagamentoVisibile
    },
    clienteVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.clienteVisibile
    },
    fornitoreVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.fornitoreVisibile
    },
    spedizioneVisibile() {
      return this.locDocumento && this.locDocumento.appoggio && this.locDocumento.appoggio.spedizioneVisibile
    },
    magazzinoVisibile() {
      return this.trigger && this.locDocumento && this.locDocumento.tipoDocumento && ['fatturaImmediata', 'ddt', 'ddtTrasferimento'].includes(this.locDocumento.tipoDocumento.codice)
    },
    magazzino2Visibile() {
      return this.trigger && this.locDocumento && this.locDocumento.tipoDocumento && ['ddtTrasferimento'].includes(this.locDocumento.tipoDocumento.codice)
    },    
    sede() {
      const destinazione = _.get(this.locDocumento, 'spedizione.destinazione', null)
      if (destinazione) {
        return destinazione
      } else {
        return this.cliente.recapiti.length > 0 ? this.cliente.recapiti[0] : {} 
      }
    },
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.headerReadOnly || this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza documento'
      } else {
        return this.locDocumento && this.locDocumento._id ? 'Modifica documento' : 'Nuovo documento'
      }
    },
    drawerSubtitle() {
      return this.updateTrigger ? _.get(this.locDocumento, 'tipoDocumento.descrizione', '') : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    nuovoArticoloCreato() {
      var na = this.$store.getters['documenti/articoloCreato'] || null
      return na
    },
    nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    },
    readOnlySeModifica() {
      return _.get(this, 'locDocumento.codice', '') !== ''
    },
    readOnlySeModificaNoTrasforma() {
      return _.get(this, 'locDocumento.codice', '') !== '' && (_.get(this, 'locDocumento.stato.codice', '') !== 'daVerificare' || _.get(this, 'locDocumento.tipoDocumento.tipoDocumento', '') !== 'trasferimento')
    },    
    itemTipoDocumento() {
      return {
        "model": "tipoDocumento.codice",
        "subModel": "codice",
        "valueField": "tipoDocumento.codice",
        "type": "Multiselect",
        "label": "Tipo documento",
        "readonly": (this.forzaTipo !== null),
       //  "source": "documenti_parametri.tipiDocumento",
        "source": this.filtraTipiDocumento && this.filtraTipiDocumento.length > 0 ? this.filtraTipiDocumento : "documenti_parametri.tipiDocumento",
        "exclude": ['ordineFornitore', 'ddtFornitore'],
        "required": true,
        "addForbidden": true,
        value: this.trigger && _.get(this.locDocumento, 'tipoDocumento.codice', '')
      }
    },
    itemData() {
      return  {
        "model": "data",
        "valueField": "data",
        "label": "Data",
        "type": "Data",
        "required": true,
        value: _.get(this.locDocumento, 'data', '')
      }
    },
    itemMagazzino() {
      return {
        "model": "magazzino",
        "subModel": "codice",
        "valueField": "magazzino",
        "type": "Multiselect",
        "label": "Magazzino movimento",
        "source": "	magazzino_magazzini.magazzini",
        "required": false,
        "addForbidden": true,
        value: _.get(this.locDocumento, 'magazzino', '')
      }
    },
    itemMagazzino2() {
      return {
        "model": "magazzino2",
        "subModel": "codice",
        "valueField": "magazzino2",
        "type": "Multiselect",
        "label": "Magazzino destinazione",
        "source": "	magazzino_magazzini.magazzini",
        "required": true,
        "addForbidden": true,
        value: _.get(this.locDocumento, 'magazzino2', '')
      }
    },
    itemCliente() {
      return {
        "model": "anagrafica.cliente",
        "valueField": "anagrafica.cliente",
        "label": "Cliente",
        "type": "Clifor",
        "required": false,
        // "showIf": "appoggio.clienteVisibile",
        "note": "tipo Cliente + solo se causale con mostra cliente",
        value: _.get(this.locDocumento, 'anagrafica.cliente', '')
      }
    },
    itemFornitore() {
      return {
        "model": "anagrafica.fornitore",
        "valueField": "anagrafica.fornitore",
        "label": "Fornitore",
        "type": "Clifor",
        "required": false,
        // "showIf": "appoggio.fornitoreVisibile",
        "note": "tipo Fornitore + solo se causale con mostra fornitore",
        value: _.get(this.locDocumento, 'anagrafica.fornitore', '')
      }
    },
    itemDestinazione() {
      console.log(this.locDocumento)
      return {
        "model": "spedizione.destinazione",
        "subModel": "",
        "valueField": "spedizione.destinazione",
        "note": "prende i recapiti del cliente (attenzione, required in alternativa a indirizzo temporaneo)",
        "type": "Destinazioni",
        "label": "Destinazione",
        "source": "destinatario",
        "required": false,
        "addForbidden": false,
        // "showIf": "appoggio.spedizioneVisibile",
        value: _.get(this.locDocumento, 'spedizione.destinazione', '')
      }
    },
    itemCodiceFiscale() {
      return {
        "model": "appoggio.clifor.amministrativi.codiceFiscale",
        "valueField": "appoggio.clifor.amministrativi.codiceFiscale",
        "label": "Codice Fiscale",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'appoggio.clifor.amministrativi.codiceFiscale', '')
      }
    },
    itemPartitaIva() {
      return {
        "model": "appoggio.clifor.amministrativi.partitaIva",
        "valueField": "appoggio.clifor.amministrativi.partitaIva",
        "label": "Partita Iva",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'appoggio.clifor.amministrativi.partitaIva', '')
      }
    },
    itemCodiceSdi() {
      return {
        "model": "appoggio.clifor.fatturazione.codiceSdi",
        "valueField": "appoggio.clifor.fatturazione.codiceSdi",
        "label": "Codice Sdi",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'appoggio.clifor.fatturazione.codiceSdi', '')
      }            
    },
    itemPagamentoCondizioni() {
      return {
        "note": "a rate, completo, anticipo",
        "model": "pagamento.condizioni",
        "subModel": "codice",
        "valueField": "pagamento.condizioni",
        "type": "Multiselect",
        "label": "Condizioni pagamento",
        "source": "documenti_pagamento.condizioniPagamento",
        "required": true,
        "addForbidden": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'pagamento.condizioni', '')
      }
    },
    itemPagamentoModalita() {
      return {
        "model": "pagamento.dettaglio.modalita",
        "subModel": "codice",
        "valueField": "pagamento.dettaglio.modalita",
        "type": "Multiselect",
        "label": "Modalità pagamento",
        "source": "documenti_pagamento.modalitaPagamento",
        "required": true,
        "addForbidden": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locDocumento, 'pagamento.dettaglio.modalita', '') || _.get(this.locDocumento, 'pagamento.modalita', '')        
      }
    }    
  },
  methods: {
    onAltriDocumenti() {
      this.dialogAltriDocumenti = !this.dialogAltriDocumenti
    },
    async onAggiornaDocumento(documentiCollegati) {
      this.locDocumento.documentiCollegati = documentiCollegati
      this.$emit('aggiornaDocumento', this.locDocumento)
    },
    datiCompleti() {
      const valid = this.$refs.form.validate()
      return valid // TODO: Completare verifica
    },
    items(idx) {
      const ret = this.documentoItems && this.documentoItems.length >= idx ? this.documentoItems[idx] : {}
      return ret
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value ? value[subModel] : ''
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locDocumento, tgt)
      await this.aggiornaCorrelati(data)
      this.$emit('aggiornaDocumento', this.locDocumento)
      // this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      // this.locDocumento.appoggio = this.locDocumento.appoggio || {}
      switch (data.model) {
         case 'tipoDocumento.codice':
          this.locDocumento.appoggio.tipoDocumento = data.value
          this.locDocumento.appoggio.clienteVisibile = _.get(data.value, 'visualizzaCliente', false)
          this.locDocumento.appoggio.fornitoreVisibile = _.get(data.value, 'visualizzaFornitore', false)
          this.locDocumento.appoggio.spedizioneVisibile = _.get(data.value, 'infoSpedizione', false)
          this.locDocumento.appoggio.pagamentoVisibile = _.get(data.value, 'infoPagamento', false)
          this.locDocumento.tipoDocumento = data.value
          // this.locDocumento.tipoDocumentoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locDocumento.appoggio.clifor = clifor
          _.set(this.locDocumento,'appoggio.clifor', clifor)
          _.set(this.locDocumento, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
          _.set(this.locDocumento, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
          const elenco = await configurazioni.getConfigurazione('documenti_pagamento', 'modalitaPagamento')
          const mp = elenco.find(x => x.codice === this.locDocumento.pagamento.dettaglio.modalita)
          if (mp) {
            _.set(this.locDocumento, 'pagamento.dettaglio.descrizione', mp.descrizione)
          }
          if (!_.get(this.locDocumento, 'spedizione.destinazione')) {
            const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
            _.set(this.locDocumento, 'spedizione.destinazione', sede)
          }
          _.set(this.locDocumento, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
          _.set(this.locDocumento, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))

          _.set(this.locDocumento, 'tipoDocumento.esigibilitaIva', _.get(this.locDocumento, 'tipoDocumento.esigibilitaIva') || _.get(this.locDocumento, 'anagrafica.cliente.amministrativi.esigibilitaIva'))
          console.log(this.locDocumento.tipoDocumento.esigibilitaIva)
          // this.noPagamento = _.get(this.locDocumento, 'pagamento.condizioni') ?  false : true
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locDocumento, 'spedizione.destinazione', data.value)
          break;
        case 'pagamento.dettaglio.modalita':
          _.set(this.locDocumento, 'pagamento.dettaglio.descrizione', _.get(data, 'value.descrizione', ''))
          break
        default:
          this.updateTrigger++
          break
      } 
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('documenti/SET_REFRESH')
      this.$store.commit('documenti/CLEAR_DOCUMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        // TODO: eliminare i campi di appoggio creati per la gestione dell'interfaccia
        this.$store.commit('documenti/SET_DOCUMENTO', this.locDocumento)
        this.$store.commit('documenti/SET_DOCUMENTO_SAVED')
      }
    }
  }
}
</script>
